<div role="dialog" aria-labelledby="dialogTitle" >
  <div class="modal-header">
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{"plan.settings.newhiretraining"|translate}}</h4>
    <button [disabled]="!_enableCancel" type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <span class="icon-Close" aria-hidden="true" ></span>
    </button>
  </div>
  <div class="modal-body">
    <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>
    <div class="col-16">
      <form #planSettingsForm (submit)="submit()">
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <input #input
                   ngbAutofocus
                   name="newHireTrainingWeeks"
                   class="form-control wfm-form-control form-control-inline"
                   [(ngModel)]="newHireTrainingWeeks"
                   required
                   autocomplete="off"
                   (input)="changedNewHireTrainingWeeks($event)"
                   (blur)="checkNewHireTrainingWeeks($event)"
                   id="newHireTrainingWeeks"
                   maxlength="2"
                   [disabled]="_isLoading || canEdit==false"
            > {{"plan.settings.weeks"|translate}}
            <div *ngIf="_showValidationError" class="error-message">{{'plan.settings.weeks.validation'|translate}}</div>
          </div>
        </div>

      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons" *ngIf="canEdit">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     [isDisabled]="!_enableCancel"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.submit.btn'|translate}}"
                     id="accept-btn"
                     [isPrimary]="true"
                     [isDisabled]="!_enableAccept"
                     (clicked)="submit()"></breeze-button>
    </div>
    <div class="modal-buttons" *ngIf="canEdit==false">
      <breeze-button buttonText="{{'plan.close.btn'|translate}}"
                     id="close-btn"
                     [isSecondary]="true"
                     [isDisabled]="!_enableCancel"
                     (clicked)="dismiss()"></breeze-button>

    </div>
  </div>
</div>
<p-toast position="bottom-center">
</p-toast>
